module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz16-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_13",
      "id": "CC_13"
    }
  }, [_vm._v(" Mayberry Hospitality Lemonade")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz16-3"
    }
  }, [_c('i', [_vm._v(" The friendly tonic. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAM-b"
    }
  }, [_c('b', [_vm._v(" 1¼ cups sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA4k"
    }
  }, [_c('b', [_vm._v(" ½ cup boiling water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pACj"
    }
  }, [_c('b', [_vm._v(" 1½ cups fresh lemon juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAgND"
    }
  }, [_c('b', [_vm._v(" 4½ cups water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAXuy"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("our sugar into boiling water, stirring until sugar dissolves. Add lemon juice and cold water. Mix well. Serve over ice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAs0"
    }
  }, [_vm._v(" Makes 7 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAFvZ"
    }
  }, [_c('i', [_vm._v("Alma Venable—Mount Airy, North Carolina")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "A0dR"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pA2r"
    }
  }, [_c('i', [_vm._v("A sucker for a snowcone:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pAysm"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "Aysm"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-Aysm-0"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-0-1"
    }
  }, [_vm._v("Boy, if I knew then what I know now. She used to do one thing that really used to burn me up.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-1"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-1-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-1-1"
    }
  }, [_vm._v("What was that?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-2-1"
    }
  }, [_vm._v("You know how I like snowcones.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-3"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-3-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-3-1"
    }
  }, [_vm._v("Raspberry.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-4"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-4-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-4-1"
    }
  }, [_vm._v("Right. Well, there wasn’t a day went by that I didn’t offer that girl a bite of my snowcone. You know what she used to do every single time?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-5"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-5-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-5-1"
    }
  }, [_vm._v("What?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-6"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-6-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-6-1"
    }
  }, [_vm._v("She used to bite off the end, sip out all the syrup, and leave me with nothing but the ice.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-7"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-7-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-7-1"
    }
  }, [_vm._v("The ice?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-8"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-8-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-8-1"
    }
  }, [_vm._v("Yeah, the ice.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-9"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-9-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-9-1"
    }
  }, [_vm._v("That’s terrible. Today you’d know different.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-10"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-10-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-10-1"
    }
  }, [_vm._v("Ha, are you kidding?! Listen, if I had a date with Vicky Harmes today and I got myself all shaved and I went over to her house with my snowcone, you know what I’d do?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-11"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-11-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-11-1"
    }
  }, [_vm._v("What?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-12"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-12-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-12-1"
    }
  }, [_vm._v("The minute she opened that door I’d bite off the end of the cone, sip out the syrup, and hand her the cone. What do you think of that?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-Aysm-13"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-Aysm-13-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-Aysm-13-1"
    }
  }, [_vm._v("Well, I’ll tell you the truth, Barn. If I was Vicky Harmes and a 35-year-old man come up to my house with a snowcone in his hands, I wouldn’t even answer the door.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3dce7ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter13.vue
// module id = 102
// module chunks = 0